module.exports = __webpack_public_path__ + "static/media/2020.7.21家风家训活动.dfebe6b0.jpg";